import React from "react";
import Hero from "@/components/sections/Hero";
import { LogoMarquee, OpsTicker, StatsBand } from "@/components/sections/Bands";
import ProofStrip from "@/components/sections/ProofStrip";
import ModuleExplorer from "@/components/sections/ModuleExplorer";
import NewModules from "@/components/sections/NewModules";
import LibraryDigest from "@/components/sections/LibraryDigest";
import { AIMatchSection, EmergencySection, FieldSection } from "@/components/sections/Showcases";
import { RolesSection, WhyFixlr, HowItWorks } from "@/components/sections/Narrative";
import { PricingSection } from "@/components/sections/Pricing";
import ROICalculator from "@/components/sections/ROICalculator";
import { Testimonials, CaseStudies, FAQSection, CTABand } from "@/components/sections/Social";
import { usePageTitle } from "@/components/ui-kit";

export default function Home() {
  usePageTitle(null);
  return (
    <div data-testid="home-page">
      <Hero />
      <ProofStrip />
      <OpsTicker />
      <LogoMarquee />
      <StatsBand />
      <ModuleExplorer />
      <NewModules />
      <LibraryDigest />
      <AIMatchSection />
      <EmergencySection />
      <FieldSection />
      <WhyFixlr />
      <RolesSection />
      <HowItWorks />
      <PricingSection />
      <ROICalculator />
      <Testimonials />
      <CaseStudies />
      <FAQSection />
      <CTABand />
    </div>
  );
}
